var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-upload"},[_c('el-upload',{ref:"fileUpload",attrs:{"http-request":_vm.httpRequest,"accept":_vm.accept,"on-change":_vm.change,"show-file-list":false,"auto-upload":false,"multiple":_vm.multiple,"drag":_vm.drag,"action":"","disabled":_vm.disabled}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }